module.exports = __webpack_public_path__ + "fonts/material-icons-round.c380809.woff2";